import angular from 'angular';
import { nl2brFilter, nl2ParagraphsFilter } from './nl2brFilter';

angular.module('sh.nl2br', []).filter('shNl2br', nl2brFilter).filter('shNl2Paragraphs', nl2ParagraphsFilter);
